<template>
    <div class="ur-data-grid__content" :style="contStyle" ref="content">
        <div class="ur-data-grid__content__freeze-wrapper" :style="freezeStyle" ref="freezeWrapper"
                v-if="!!freezeWidth" @wheel="onWheelFixed">
            <group-node v-for="(r,i) in gridInfo.data" :data="r" :key="i" freeze/>
        </div>
        <div class="ur-data-grid__content__scroll-wrapper" :style="scrollStyle" ref="scrollWrapper" @wheel="onWheelFixed">
            <group-node v-for="(r,i) in gridInfo.data" :data="r" :key="i"/>
        </div>
        <!-- Vertical accordion -->
        <accrd-row :row="gridInfo.vars_accordionRow" vertical v-if="gridInfo.vars_accordionRow && isVertAcc"/>
        <!-- Pseudo scroll, please check also 'WrapperMixin' -->
        <p-scroll @on-scroll="onPseudoScroll" ref="pScroll"/>
        <!-- anchro for tooltip -->
        <div class="ur-data-grid__content__scroll-tooltip" :style="scrollStyle" ref="scrollTooltip"/>
    </div>
</template>

<script>
//[IMPORT] Sub components
import groupNode from './sub/urFullGridContentGroupNode.vue';
import accrdRow  from '../row/urDataGridContentAccordionRow.js';
import pScroll   from './sub/urDataGridContentPseudoScroll.vue';
//[IMPORT] Util function
import wrapperMixin from './mixin/urDataGridContentWrapperMixin';

export default {
    name : "urFullGridContentGrouping",
    inject : ['gridInfo'],
    mixins : [wrapperMixin],
    components : {groupNode, pScroll, accrdRow},
    computed : {

        freezeWidth() {
            this.$nextTick(()=>{
                // freeze 보이기 여부에 따라 freezeWrapper를 다시 설정해주어야만 scroll이 먹음.
                // 안 할 경우 div의 부모가 없어 scroolTop 을 줘도 먹지가 않음
                this.gridInfo.func.setRefs('freezeWrapper',this.$refs.freezeWrapper);
            })
            return this.gridInfo.vars_freezeWidth
        },
        scrollStyle()   {return {
            "width"      :`calc(100% - ${this.freezeWidth}px)`,
            "margin-left":`${this.freezeWidth}px`
        }},
        // [COMPUTED][STYLE] Style of freeze scroller
        freezeStyle() {return {width:this.freezeWidth+'px'}},
        isVertAcc() {return this.gridInfo.vars_accordionVert},
    },
    mounted() {
        this.gridInfo.func.setRefs('content'      ,this.$refs.content);
        this.gridInfo.func.setRefs('scrollWrapper',this.$refs.scrollWrapper);
        this.gridInfo.func.setRefs('scrollTooltip',this.$refs.scrollTooltip);
    },
}
</script>